import { api } from '../api.js';

export const tenantMemberApplicationAPI = {
  getJoinOptions: () => api.get('/tenant-member-applications/join-options'),
  lookupByCode: (tenantCode) => api.get('/tenant-member-applications/lookup', { params: { tenantCode } }),
  listMine: () => api.get('/tenant-member-applications/mine'),
  submit: (payload) => api.post('/tenant-member-applications', payload),
  cancel: (id) => api.post(`/tenant-member-applications/${id}/cancel`),
  listForReview: (params = {}) => api.get('/tenant-member-applications', { params }),
  approve: (id, reviewComment) => api.post(`/tenant-member-applications/${id}/approve`, { reviewComment }),
  reject: (id, reviewComment) => api.post(`/tenant-member-applications/${id}/reject`, { reviewComment }),
};
